import { Selector } from '@/components/jog/Selector';
import {
  FEED_OVERRIDE_OPTIONS,
  FEED_PERCENTS,
  nearestIndex,
  SPINDLE_OVERRIDE_OPTIONS,
  SPINDLE_PERCENTS,
} from '@/components/jog/overrideOptions';
import { useFeedOverride, useSendCommand, useSpindleOverride } from '@/store/store';
import styles from '@/components/jog/jog.module.css';

/** Feed + Spindle override carousel selectors — active option driven by machine read-back. */
export function OverridePanel(): JSX.Element {
  const sendCommand = useSendCommand();
  const feedOverride = useFeedOverride();
  const spindleOverride = useSpindleOverride();

  const feedIndex = nearestIndex(FEED_PERCENTS, feedOverride);
  const spindleIndex = nearestIndex(SPINDLE_PERCENTS, spindleOverride);

  return (
    <div className={`${styles.jogCard} ${styles.jogOverrideCard}`}>
      <span className={styles.jogCardTitle}>Overrides</span>
      <hr className={styles.jogCardDivider} />
      <Selector
        label="Feed Override"
        options={FEED_OVERRIDE_OPTIONS}
        activeIndex={feedIndex}
        onChange={(i) => sendCommand({ type: 'FEED_OVERRIDE', percent: FEED_PERCENTS[i] ?? 100 })}
        windowSize={5}
      />
      <hr className={styles.jogCardDivider} />
      <Selector
        label="Spindle Override"
        options={SPINDLE_OVERRIDE_OPTIONS}
        activeIndex={spindleIndex}
        onChange={(i) =>
          sendCommand({ type: 'SPINDLE_OVERRIDE', percent: SPINDLE_PERCENTS[i] ?? 100 })
        }
        windowSize={5}
      />
    </div>
  );
}
